export function toMidnight(date: Date) {
    const midnight = new Date(date.getTime());
    midnight.setHours(0);
    midnight.setMinutes(0);
    midnight.setSeconds(0);
    midnight.setMilliseconds(0);
    return midnight;
}

/**
 * 二つのDateの日付の差分を取得する
 * @param a Date
 * @param b Date
 * @return aの日付-bの日付
 */
export function getDateDiff(a: Date, b: Date) {
    const milliDiff = toMidnight(a).getTime() - toMidnight(b).getTime();
    return Math.ceil(milliDiff / (1000 * 60 * 60 * 24));
}

/**
 * yyyyMMdd形式の文字列を返す
 * @param date Date
 */
export function getYYYYMMDD(date: Date) {
    return date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2)
}